import { PageGen, PdfRect, PdfUnit, PdfBrush, PdfColor, PdfPoint, ETextAlign } from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaBlack implements IColorSchema {
  readonly name = 'Black';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    let left = rect.x;
    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;

    if (counter) {
      const s1 = page.measureString(counter, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);

      page.drawRectangle(null, PdfBrush.Black, r);
      page.drawString(counter, font, PdfBrush.White, null, r, ETextAlign.Center);

      left += r.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    page.drawLine(
      GUtil.writePen,
      new PdfPoint(rect.right, rect.bottom),
      new PdfPoint(rect.x, rect.bottom)
    );
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader,
      rect.width,
      rect.height - this.sizeTopHeader
    );
  }
}
